/*
 * @Author: 17388316638 lemon1234..
 * @Date: 2022-09-09 10:04:53
 * @LastEditors: 17388316638 lemon1234..
 * @LastEditTime: 2022-09-16 13:51:58
 * @FilePath: \qcsdjyBigdataUI\src\tool\http.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "axios";
import Vue from "vue";

import NProgress from "nprogress";
import "nprogress/nprogress.css";
const CancelToken = axios.CancelToken;
//默认超时时间
// axios.defaults.timeout = 20000;

const environment = process.env.NODE_ENV == "development";

axios.defaults.baseURL = "";
// axios.defaults.baseURL = environment ? "" : "http://220.167.103.90:8091/";

// axios.defaults.headers["Content-Type"] = "application/json;charset=UTF-8";

const request = axios.create({
  timeout: 30000,
});

//返回其他状态码
request.defaults.validateStatus = function (status) {
  return status >= 200 && status <= 500;
};
//跨域请求，允许保存cookie
request.defaults.withCredentials = true;

request.interceptors.request.use(
  (config) => {
    //开启 progress bar
    NProgress.start();
    config.cancelToken = new CancelToken(function executor(c) {
      Vue.prototype.$currentHttpRequestList.set(config.url, c);
    });
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截
request.interceptors.response.use(
  (res) => {
    NProgress.done();
    // 进度条结束
    // res.data.code = 1001
    // setTimeout(()=>{
    //   NProgress.done()
    // },13000)
    return res;
  },
  (error) => {
    return Promise.reject(new Error(error));
  }
);

export default request;
